/* Testimonial enhancements: inject a star row into each card and reveal
   cards on scroll. Purely additive -- no theme markup is modified. */
(function () {
  'use strict';

  var STAR = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">' +
             '<path d="M12 2.6l2.9 5.9 6.5.95-4.7 4.6 1.1 6.45L12 17.45 ' +
             '6.2 20.5l1.1-6.45-4.7-4.6 6.5-.95z"/></svg>';

  function cards() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.testimonials__items > .f-column')
    );
  }

  function addStars(card) {
    if (card.querySelector('.ts-stars')) return;
    var host = card.querySelector('.testimonial__content') ||
               card.querySelector('.testimonial__inner');
    if (!host) return;
    var wrap = document.createElement('div');
    wrap.className = 'ts-stars';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = STAR.repeat(5);
    host.parentNode.insertBefore(wrap, host);
  }

  function init() {
    var list = cards();
    if (!list.length) return;
    list.forEach(addStars);

    if (!('IntersectionObserver' in window)) {
      list.forEach(function (c) { c.classList.add('ts-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ts-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });

    list.forEach(function (c) { io.observe(c); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
